import axios from 'axios'

import { getToken, PUBLIC_ROUTES } from 'helpers'

const getEnviroment = () => {
  // return 'http://127.0.0.1:8082'

  switch (process.env.NEXT_PUBLIC_NODE_ENV) {
    case 'production':
      return 'https://api-prod.kavodlending.com'
    case 'homolog':
      return 'https://api-hmg.kavodlending.com'
    case 'dev':
    default:
      return 'https://api-dev.kavodlending.com'
  }
}

export const __API__ = getEnviroment()

const defaultOptions = {
  baseURL: __API__
}

const instance = axios.create(defaultOptions)

instance.interceptors.request.use(config => {
  const token = getToken()

  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: token ? `Bearer ${token}` : ''
    }
  }
})

instance.interceptors.response.use(
  response => response.data,
  error => {
    if (
      (error && error.response && error.response.status !== 401) ||
      PUBLIC_ROUTES.includes(window.location.pathname)
    ) {
      return Promise.reject(error)
    }
  }
)

export default instance
